import React from 'react';
import { useGlobal } from 'reactn';
import Card from '../../common/card/Card';
import waterIcon from '../../assets/WaterIcon.png';
import downGreenArrowIcon from '../../assets/downGreenArrow.png';
import redArrowIcon from '../../assets/ArrowRed.png';
import { formatPercentage } from '../../../helpers';

const UsageAtGlance = ({ ...rest }) => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  if (!selectedServiceAccount) {
    return <h4>Getting consumption data. Please wait...</h4>;
  }

  const { consumptionData } = selectedServiceAccount;
  const CONS = consumptionData[0]?.CONS;
  const COMPARE_CONS = consumptionData[0]?.COMPARE_CONS;

  return (
    <Card title="Usage at a Glance" className="h-full" waterConsumptionColor>
      {CONS && COMPARE_CONS ? (
        <div className="flex flex-col items-stretch justify-center h-full">
          <div className="flex justify-around">
            <div className="flex-col justify-between items-center w-1/4">
              <img
                src={waterIcon}
                alt="water-icon"
                className="mr-auto ml-auto mb-5"
              />
              {(CONS - COMPARE_CONS) / COMPARE_CONS > 0 ? (
                <img src={redArrowIcon} alt="up-red-icon" className="m-auto" />
              ) : (
                <img
                  src={downGreenArrowIcon}
                  alt="down-green-icon"
                  className="m-auto"
                />
              )}
            </div>
            <div className="flex-col justify-between items-center w-1/2">
              <p className="m-0 w-3/4">You Used</p>
              <p className="text-3xl text-blue-500 font-bold w-3/4">
                {formatPercentage(Math.abs((CONS - COMPARE_CONS) / COMPARE_CONS))}
              </p>
              <p className="w-3/4">
                {CONS < COMPARE_CONS
                  ? 'Less '
                  : CONS > COMPARE_CONS
                  ? 'More '
                  : ''}
                water compared to this quarter last year.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <h4>Getting consumption data. Please wait...</h4>
      )}
    </Card>
  );
};

export default UsageAtGlance;
